<template>
  <div>
    <div class="pb-4 -m-2 flex flex-wrap">
      <div class="p-2 w-full md:w-1/3">
        <widget-orders-count class="box "/>
      </div>
      <div class="p-2 w-full md:w-1/3">
        <widget-customers-count class="box"/>
      </div>
      <div class="p-2 w-full md:w-1/3">
        <widget-products-count class="box"/>
      </div>
    </div>
    <div class="box">
      <widget-orders-chart/>
    </div>
  </div>
</template>

<script>
import WidgetOrdersChart from '../components/widgets/OrdersChartWidget.vue';
import WidgetOrdersCount from '../components/widgets/OrdersCountWidget.vue';
import WidgetCustomersCount from '../components/widgets/CustomersCountWidget.vue';
import WidgetProductsCount from '../components/widgets/ProductsCountWidget.vue';

export default {
  components: {
    WidgetOrdersChart,
    WidgetOrdersCount,
    WidgetCustomersCount,
    WidgetProductsCount,
  },
};
</script>
